import _defineProperty from "/workspace/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/workspace/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { rectToClientRect as t, computePosition as e } from "@floating-ui/core";
export { arrow, autoPlacement, detectOverflow, flip, hide, inline, limitShift, offset, shift, size } from "@floating-ui/core";

function n(t) {
  return t && t.document && t.location && t.alert && t.setInterval;
}

function o(t) {
  if (null == t) return window;

  if (!n(t)) {
    var _e = t.ownerDocument;
    return _e && _e.defaultView || window;
  }

  return t;
}

function i(t) {
  return o(t).getComputedStyle(t);
}

function r(t) {
  return n(t) ? "" : t ? (t.nodeName || "").toLowerCase() : "";
}

function l() {
  var t = navigator.userAgentData;
  return null != t && t.brands ? t.brands.map(function (t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}

function c(t) {
  return t instanceof o(t).HTMLElement;
}

function f(t) {
  return t instanceof o(t).Element;
}

function s(t) {
  if ("undefined" == typeof ShadowRoot) return !1;
  return t instanceof o(t).ShadowRoot || t instanceof ShadowRoot;
}

function u(t) {
  var _i = i(t),
      e = _i.overflow,
      n = _i.overflowX,
      o = _i.overflowY;

  return /auto|scroll|overlay|hidden/.test(e + o + n);
}

function d(t) {
  return ["table", "td", "th"].includes(r(t));
}

function h(t) {
  var e = /firefox/i.test(l()),
      n = i(t);
  return "none" !== n.transform || "none" !== n.perspective || "paint" === n.contain || ["transform", "perspective"].includes(n.willChange) || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter;
}

function a() {
  return !/^((?!chrome|android).)*safari/i.test(l());
}

var g = Math.min,
    p = Math.max,
    m = Math.round;

function w(t, e, n) {
  var i, r, l, s;
  void 0 === e && (e = !1), void 0 === n && (n = !1);
  var u = t.getBoundingClientRect();
  var d = 1,
      h = 1;
  e && c(t) && (d = t.offsetWidth > 0 && m(u.width) / t.offsetWidth || 1, h = t.offsetHeight > 0 && m(u.height) / t.offsetHeight || 1);
  var g = f(t) ? o(t) : window,
      p = !a() && n,
      w = (u.left + (p && null != (i = null == (r = g.visualViewport) ? void 0 : r.offsetLeft) ? i : 0)) / d,
      v = (u.top + (p && null != (l = null == (s = g.visualViewport) ? void 0 : s.offsetTop) ? l : 0)) / h,
      y = u.width / d,
      x = u.height / h;
  return {
    width: y,
    height: x,
    top: v,
    right: w + y,
    bottom: v + x,
    left: w,
    x: w,
    y: v
  };
}

function v(t) {
  return (e = t, (e instanceof o(e).Node ? t.ownerDocument : t.document) || window.document).documentElement;
  var e;
}

function y(t) {
  return f(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}

function x(t) {
  return w(v(t)).left + y(t).scrollLeft;
}

function b(t, e, n) {
  var o = c(e),
      i = v(e),
      l = w(t, o && function (t) {
    var e = w(t);
    return m(e.width) !== t.offsetWidth || m(e.height) !== t.offsetHeight;
  }(e), "fixed" === n);
  var f = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var s = {
    x: 0,
    y: 0
  };
  if (o || !o && "fixed" !== n) if (("body" !== r(e) || u(i)) && (f = y(e)), c(e)) {
    var _t = w(e, !0);

    s.x = _t.x + e.clientLeft, s.y = _t.y + e.clientTop;
  } else i && (s.x = x(i));
  return {
    x: l.left + f.scrollLeft - s.x,
    y: l.top + f.scrollTop - s.y,
    width: l.width,
    height: l.height
  };
}

function L(t) {
  return "html" === r(t) ? t : t.assignedSlot || t.parentNode || (s(t) ? t.host : null) || v(t);
}

function R(t) {
  return c(t) && "fixed" !== getComputedStyle(t).position ? t.offsetParent : null;
}

function T(t) {
  var e = o(t);
  var n = R(t);

  for (; n && d(n) && "static" === getComputedStyle(n).position;) {
    n = R(n);
  }

  return n && ("html" === r(n) || "body" === r(n) && "static" === getComputedStyle(n).position && !h(n)) ? e : n || function (t) {
    var e = L(t);

    for (s(e) && (e = e.host); c(e) && !["html", "body"].includes(r(e));) {
      if (h(e)) return e;
      e = e.parentNode;
    }

    return null;
  }(t) || e;
}

function W(t) {
  if (c(t)) return {
    width: t.offsetWidth,
    height: t.offsetHeight
  };
  var e = w(t);
  return {
    width: e.width,
    height: e.height
  };
}

function E(t) {
  var e = L(t);
  return ["html", "body", "#document"].includes(r(e)) ? t.ownerDocument.body : c(e) && u(e) ? e : E(e);
}

function H(t, e) {
  var n;
  void 0 === e && (e = []);
  var i = E(t),
      r = i === (null == (n = t.ownerDocument) ? void 0 : n.body),
      l = o(i),
      c = r ? [l].concat(l.visualViewport || [], u(i) ? i : []) : i,
      f = e.concat(c);
  return r ? f : f.concat(H(c));
}

function C(e, n, r) {
  return "viewport" === n ? t(function (t, e) {
    var n = o(t),
        i = v(t),
        r = n.visualViewport;
    var l = i.clientWidth,
        c = i.clientHeight,
        f = 0,
        s = 0;

    if (r) {
      l = r.width, c = r.height;

      var _t2 = a();

      (_t2 || !_t2 && "fixed" === e) && (f = r.offsetLeft, s = r.offsetTop);
    }

    return {
      width: l,
      height: c,
      x: f,
      y: s
    };
  }(e, r)) : f(n) ? function (t, e) {
    var n = w(t, !1, "fixed" === e),
        o = n.top + t.clientTop,
        i = n.left + t.clientLeft;
    return {
      top: o,
      left: i,
      x: i,
      y: o,
      right: i + t.clientWidth,
      bottom: o + t.clientHeight,
      width: t.clientWidth,
      height: t.clientHeight
    };
  }(n, r) : t(function (t) {
    var e;
    var n = v(t),
        o = y(t),
        r = null == (e = t.ownerDocument) ? void 0 : e.body,
        l = p(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0),
        c = p(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0);
    var f = -o.scrollLeft + x(t);
    var s = -o.scrollTop;
    return "rtl" === i(r || n).direction && (f += p(n.clientWidth, r ? r.clientWidth : 0) - l), {
      width: l,
      height: c,
      x: f,
      y: s
    };
  }(v(e)));
}

function S(t) {
  var e = H(t),
      n = ["absolute", "fixed"].includes(i(t).position) && c(t) ? T(t) : t;
  return f(n) ? e.filter(function (t) {
    return f(t) && function (t, e) {
      var n = null == e.getRootNode ? void 0 : e.getRootNode();
      if (t.contains(e)) return !0;

      if (n && s(n)) {
        var _n = e;

        do {
          if (_n && t === _n) return !0;
          _n = _n.parentNode || _n.host;
        } while (_n);
      }

      return !1;
    }(t, n) && "body" !== r(t);
  }) : [];
}

var D = {
  getClippingRect: function getClippingRect(t) {
    var e = t.element,
        n = t.boundary,
        o = t.rootBoundary,
        i = t.strategy;
    var r = [].concat(_toConsumableArray("clippingAncestors" === n ? S(e) : [].concat(n)), [o]),
        l = r[0],
        c = r.reduce(function (t, n) {
      var o = C(e, n, i);
      return t.top = p(o.top, t.top), t.right = g(o.right, t.right), t.bottom = g(o.bottom, t.bottom), t.left = p(o.left, t.left), t;
    }, C(e, l, i));
    return {
      width: c.right - c.left,
      height: c.bottom - c.top,
      x: c.left,
      y: c.top
    };
  },
  convertOffsetParentRelativeRectToViewportRelativeRect: function convertOffsetParentRelativeRectToViewportRelativeRect(t) {
    var e = t.rect,
        n = t.offsetParent,
        o = t.strategy;
    var i = c(n),
        l = v(n);
    if (n === l) return e;
    var f = {
      scrollLeft: 0,
      scrollTop: 0
    };
    var s = {
      x: 0,
      y: 0
    };

    if ((i || !i && "fixed" !== o) && (("body" !== r(n) || u(l)) && (f = y(n)), c(n))) {
      var _t3 = w(n, !0);

      s.x = _t3.x + n.clientLeft, s.y = _t3.y + n.clientTop;
    }

    return _objectSpread(_objectSpread({}, e), {}, {
      x: e.x - f.scrollLeft + s.x,
      y: e.y - f.scrollTop + s.y
    });
  },
  isElement: f,
  getDimensions: W,
  getOffsetParent: T,
  getDocumentElement: v,
  getElementRects: function getElementRects(t) {
    var e = t.reference,
        n = t.floating,
        o = t.strategy;
    return {
      reference: b(e, T(n), o),
      floating: _objectSpread(_objectSpread({}, W(n)), {}, {
        x: 0,
        y: 0
      })
    };
  },
  getClientRects: function getClientRects(t) {
    return Array.from(t.getClientRects());
  },
  isRTL: function isRTL(t) {
    return "rtl" === i(t).direction;
  }
};

function N(t, e, n, o) {
  void 0 === o && (o = {});
  var _o = o,
      _o$ancestorScroll = _o.ancestorScroll,
      i = _o$ancestorScroll === void 0 ? !0 : _o$ancestorScroll,
      _o$ancestorResize = _o.ancestorResize,
      r = _o$ancestorResize === void 0 ? !0 : _o$ancestorResize,
      _o$elementResize = _o.elementResize,
      l = _o$elementResize === void 0 ? !0 : _o$elementResize,
      _o$animationFrame = _o.animationFrame,
      c = _o$animationFrame === void 0 ? !1 : _o$animationFrame,
      s = i && !c,
      u = r && !c,
      d = s || u ? [].concat(_toConsumableArray(f(t) ? H(t) : []), _toConsumableArray(H(e))) : [];
  d.forEach(function (t) {
    s && t.addEventListener("scroll", n, {
      passive: !0
    }), u && t.addEventListener("resize", n);
  });
  var h,
      a = null;

  if (l) {
    var _o2 = !0;

    a = new ResizeObserver(function () {
      _o2 || n(), _o2 = !1;
    }), f(t) && !c && a.observe(t), a.observe(e);
  }

  var g = c ? w(t) : null;
  return c && function e() {
    var o = w(t);
    !g || o.x === g.x && o.y === g.y && o.width === g.width && o.height === g.height || n();
    g = o, h = requestAnimationFrame(e);
  }(), n(), function () {
    var t;
    d.forEach(function (t) {
      s && t.removeEventListener("scroll", n), u && t.removeEventListener("resize", n);
    }), null == (t = a) || t.disconnect(), a = null, c && cancelAnimationFrame(h);
  };
}

var z = function z(t, n, o) {
  return e(t, n, _objectSpread({
    platform: D
  }, o));
};

export { N as autoUpdate, z as computePosition, H as getOverflowAncestors };